/**
 * Utility interfaces, functions for data-visualization.
 * Use `apply` method to in your component to use them.
 */

/**
 * Fetches Neptune default chart colors from sematic-token.css. By reading computed styles, tokens from host/root.
 * @returns [] A collection of the colors.
 * @throws "data-visualization-util: Cannot get computed styles for host styles"
 * @throws "data-visualization-util: No colorList found for hostStyles."
 */
function getChartColors() {

    let colorList = [];
    const hostStyles = getComputedStyle(this);

    if (undefined === hostStyles) {
        throw new Error('data-visualization-util: Cannot get computed styles for host styles');
    }

    for (let colorTokenIndex = 1, numberOfColorTokens = 20; colorTokenIndex < numberOfColorTokens; colorTokenIndex++) {
        colorList.push(hostStyles?.getPropertyValue('--neptune-chart-color-' + colorTokenIndex).trim());
    }

    if (!colorList.length > 0) {
        throw new Error('data-visualization-util: No colorList found for hostStyles.');
    }

    return colorList;
}

/**
 * Changes the structure of raw data to adapt to Highcharts.
 * From [a, b, c] to {data: [a, b, c]}
 *
 * @param seriesData
 * @returns {*[]} Normalized series data collection.
 * @throws "data-visualization-util: Cannot normalize series data, since no data exists."
 */
function normalizeSeriesData(seriesData) {

    let normalizedSeriesData = [];

    if (undefined == seriesData) {
        throw new Error('data-visualization-util: Cannot normalize series data, since no data exists.');
    }

    for (let seriesIndex = 0, numberOfSeries = seriesData.length; seriesIndex < numberOfSeries; seriesIndex++) {
        normalizedSeriesData[seriesIndex] = { data: seriesData[seriesIndex] };
    }

    return normalizedSeriesData;
}

/**
 * Combines the series names/labels with series data.
 *
 * @param seriesNames
 * @param seriesData
 * @returns [] Series data combined with series name.
 * @throws "data-visualization-util: No seriesData for to render."
 * @throws "ata-visualization-util: Number of series and names do not match."
 */
function combineNamesWithSeries(seriesNames, seriesData) {
    let seriesWithNames = [];

    if (seriesNames.length === 0) {
        return seriesWithNames;
    }

    if (seriesData.length === 0) {
        console.error('data-visualization-util: No seriesData for to render.');
        throw new Error('data-visualization-util: No seriesData for to render.');
    }

    if (seriesData.length !== seriesNames.length) {
        console.error('data-visualization-util: Number of series and names do not match.');
        throw new Error('data-visualization-util: Number of series and names do not match.');
    }

    for (let seriesIndex = 0, numberOfSeries = seriesNames.length; seriesIndex < numberOfSeries; seriesIndex++) {
        seriesData[seriesIndex].name = seriesNames[seriesIndex];
        seriesWithNames[seriesIndex] = seriesData[seriesIndex];
    }

    return seriesWithNames;
}

export default {getChartColors, normalizeSeriesData, combineNamesWithSeries}